import {
  BaseNotificationsClient,
  MarkAsReadParams,
  MarkAsReadResponse,
  Notification,
  NotificationsPayload,
  NotificationTypesPayload,
  NotificationTypeItem,
  UnreadCountResponse,
  FetchReadRecordsParams,
  FetchReadNotificationIdsParams,
  NotificationReadRecord,
} from "@core/types";
import { SupaNotifications } from "../types/supabaseFragments";
import { convertNotifications } from "./converters";

class NotificationClient extends BaseNotificationsClient {
  async getNotificationTypes(params?: NotificationTypesPayload): Promise<NotificationTypeItem[]> {
    const { data } = await this.instance.get<NotificationTypeItem[]>("/wp-json/parhato-api/v1/notification/types");
    console.log({data})

    return data || [];
  }

  async getNotifications(params?: NotificationsPayload): Promise<Notification[]> {
    const searchParams = new URLSearchParams();
    
    if (params?.page) searchParams.append("page", params.page.toString());
    if (params?.perPage) searchParams.append("per_page", params.perPage.toString());
    if (params?.type) searchParams.append("type", params.type);
    if (params?.search) searchParams.append("search", params.search);

    const { data } = await this.instance.get<SupaNotifications[]>(
      `/wp-json/parhato-api/v1/notification?${searchParams.toString()}`
    );

    return data ? data.map(convertNotifications) : [];
  }

  async markAsRead(params: MarkAsReadParams): Promise<MarkAsReadResponse> {
    const { data } = await this.instance.post<MarkAsReadResponse>("/wp-json/parhato-api/v1/notification/mark-read", {
      notificationId: params.notificationId,
      markAllAsRead: params.markAllAsRead || false,
    });

    return data || { success: false, message: "Failed to mark as read" };
  }

  async getUnreadCount(): Promise<UnreadCountResponse> {
    const { data } = await this.instance.get<UnreadCountResponse>("/wp-json/parhato-api/v1/notification/unread-count");

    return data || { unreadCount: 0 };
  }

  async fetchReadRecords(params: FetchReadRecordsParams): Promise<NotificationReadRecord[]> {
    const ids = params.notificationIds.join(",");
    const { data } = await this.instance.get<NotificationReadRecord[]>(
      `/wp-json/parhato-api/v1/notification/read-records?ids=${ids}`
    );

    return data || [];
  }

  async fetchReadNotificationIds(params: FetchReadNotificationIdsParams): Promise<number[]> {
    const { data } = await this.instance.get<number[]>("/wp-json/parhato-api/v1/notification/read-notification-ids");

    return data || [];
  }
}

export default NotificationClient;
